function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupervisedWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.25H7.5v13.5h3v-4.5h2.25c2.482 0 4.5-2.018 4.5-4.5 0-2.483-2.018-4.5-4.5-4.5Zm.15 6h-2.4v-3h2.4c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "nonzero"
    },
    d: "M13.653 14.817h4.3v4.3h-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.878 16.25h-.179v-.358a.896.896 0 1 0-1.792 0v.358h-.179a.359.359 0 0 0-.358.358V18.4c0 .197.161.358.358.358h2.15a.36.36 0 0 0 .359-.358v-1.792a.36.36 0 0 0-.359-.358Zm-1.075 1.613a.359.359 0 1 1 .359-.359.36.36 0 0 1-.359.359Zm.556-1.613h-1.111v-.358a.556.556 0 1 1 1.111 0v.358Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedWhite);
export default __webpack_public_path__ + "static/media/supervised-white.16807272aca9bb1b32f968d11949a184.svg";
export { ForwardRef as ReactComponent };